import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  amenities: {
    bathroom: 0,
    bedroom: 0,
    bed: 0,
    squareFeet: "",
  },
  priceRange: { min: 0, max: 10000 }, // Set minimum to 0
  propertyType: null,
  filter: null,
  amenitiesEssentials: null,
  instantBook: false,
  allowPets: false,
  // New properties for price range statistics
  priceRangeStats: {
    minPrice: 0, // Set minimum to 0
    maxPrice: 10000,
    priceDistribution: Array(30).fill(0),
    totalListings: 0
  },
  listingsInRange: 0,
  isLoadingPriceStats: false
};

export const SearchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setAmenities: (state, action) => {
      state.amenities = action.payload;
    },
    setPriceRange: (state, action) => {
      state.priceRange = action.payload;
    },
    setPropertyType: (state, action) => {
      state.propertyType = action.payload;
    },
    setAmenitiesEssentials: (state, action) => {
      state.amenitiesEssentials = action.payload;
    },
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
    setInstantBook: (state, action) => {
      state.instantBook = action.payload;
    },
    setAllowPets: (state, action) => {
      state.allowPets = action.payload;
    },
    // New reducers for price range statistics
    setPriceRangeStats: (state, action) => {
      state.priceRangeStats = action.payload;
    },
    setListingsInRange: (state, action) => {
      state.listingsInRange = action.payload;
    },
    setIsLoadingPriceStats: (state, action) => {
      state.isLoadingPriceStats = action.payload;
    },
    resetSearchState: () => initialState,
    
    // Or a partial reset for specific problematic state
    clearSearchFilters: (state) => {
      state.filter = null;
      state.priceRange = null;
      state.propertyType = null;
      state.amenitiesEssentials = null;
    },
  },
});

export const {
  setAmenities,
  setAmenitiesEssentials,
  setFilter,
  setPriceRange,
  setPropertyType,
  setAllowPets,
  setInstantBook,
  setPriceRangeStats,
  setListingsInRange,
  setIsLoadingPriceStats,
  resetSearchState,
  clearSearchFilters 
} = SearchSlice.actions;

export default SearchSlice.reducer;
